// src/lib/supabaseClient.ts
import { createClient } from "@supabase/supabase-js";
import { ENV } from "../env";
import type { Database } from "../types/database.types";

export const supabase = createClient<Database>(ENV.SUPABASE_URL, ENV.ANON_KEY, {
  auth: {
    flowType: "implicit", // Token im URL-Hash, funktioniert cross-browser ohne code_verifier
  },
  global: {
    headers: {
      Accept: "application/json",
    },
  },
});
